import getConfig from 'next/config';
import { useRouter } from 'next/router';
import React from 'react';

import { DesktopHeader, MobileHeader } from '@sravni/react-header';
import { GlobalSearch } from '@sravni/react-search/lib/GlobalSearch';
import { useIsMobile } from '@sravni/react-utils';

import { useCurrentUserLocation } from '../../store/hooks/locations';
import { useSiteSettings } from '../../store/hooks/sitesettings';
import { useUser } from '../../store/hooks/users';

const searchUrl = getConfig().publicRuntimeConfig.publicUrl;

export default function Header() {
  const { asPath } = useRouter();
  const settings = useSiteSettings();
  const isMobile = useIsMobile();
  const user = useUser();
  const currentUserLocation = useCurrentUserLocation();

  const AlterableHeader = isMobile ? MobileHeader : DesktopHeader;

  return (
    <AlterableHeader
      currentRegion={currentUserLocation}
      settings={settings.header}
      user={user}
      enableTheme
      search={<GlobalSearch searchServiceHost={searchUrl} asPath={asPath} />}
    />
  );
}
